import React, { useState } from "react";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { FaPlus, FaSave, FaTimes, FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";

const AddNewItemForm = ({ onBack }) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    unit: "",
    description: "",
    min_stock: "",
    barcode: "",
    brand: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("New Item Data:", formData);
    toast.success("New item added successfully!");
    setFormData({
      name: "",
      category: "",
      unit: "",
      description: "",
      min_stock: "",
      barcode: "",
      brand: ""
    });
    if (onBack) onBack();
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Card className="border-0 shadow-sm">
      <Card.Header className="bg-primary text-white d-flex align-items-center">
        <FaPlus className="me-2" />
        <h5 className="mb-0">Add New Item</h5>
        {onBack && (
          <Button
            variant="light"
            size="sm"
            className="ms-auto"
            onClick={onBack}
          >
            <FaArrowLeft className="me-1" />
            Back
          </Button>
        )}
      </Card.Header>
      <Card.Body className="p-4">
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Item Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                  className="form-control-lg"
                  placeholder="Enter item name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Category *</Form.Label>
                <Form.Select
                  value={formData.category}
                  onChange={(e) => handleChange('category', e.target.value)}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select Category</option>
                  <option value="Grains">Grains</option>
                  <option value="Meat">Meat</option>
                  <option value="Vegetables">Vegetables</option>
                  <option value="Beverages">Beverages</option>
                  <option value="Dairy">Dairy</option>
                  <option value="Spices">Spices</option>
                  <option value="Oil">Oil</option>
                  <option value="Frozen">Frozen</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Unit *</Form.Label>
                <Form.Select
                  value={formData.unit}
                  onChange={(e) => handleChange('unit', e.target.value)}
                  required
                  className="form-select-lg"
                >
                  <option value="">Select Unit</option>
                  <option value="KG">KG</option>
                  <option value="PCS">PCS</option>
                  <option value="LTR">LTR</option>
                  <option value="PKT">PKT</option>
                  <option value="BOX">BOX</option>
                  <option value="BTL">BTL</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Minimum Stock Level</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.min_stock}
                  onChange={(e) => handleChange('min_stock', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter minimum stock level"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Brand</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.brand}
                  onChange={(e) => handleChange('brand', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter brand name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Barcode</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.barcode}
                  onChange={(e) => handleChange('barcode', e.target.value)}
                  className="form-control-lg"
                  placeholder="Enter barcode"
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              placeholder="Enter item description..."
              className="form-control-lg"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-3">
            {onBack && (
              <Button 
                variant="outline-secondary" 
                size="lg"
                onClick={onBack}
              >
                <FaTimes className="me-1" />
                Cancel
              </Button>
            )}
            <Button 
              variant="primary" 
              type="submit" 
              size="lg"
              className="px-4"
            >
              <FaSave className="me-1" />
              Add Item
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddNewItemForm;
